import nurAlHudaImg from './img/about-nbg.png';
import nurAlHudaForKidsImg from './img/nuralhudaforkids.png';
import islamicSocraticMethodImg from './img/islamic_socratic_method.png';
import iqraWithUsImg from './img/Nuralhuda-applogo.png';
import paliGPTImg from './img/PaliGPT.png';
import muslimReferenceAIIMG from './img/muslimReferenceAI.png';
import fiveDThinkingImg from './img/5dlogotransparent.png';
import nurTutorImg from './img/nurtutor.png';

export const titleToChatbotTypeMap = {
  'Nur Al Huda': 'nurAlHuda',
  'Nur Al Huda For Kids': 'nurAlHudaForKids',
  'Islamic Socratic Method': 'islamicSocraticMethod',
  'Iqra With Us': 'iqraWithUs',
  'Nur Tutor': 'nurTutor',
  //'Muslim Reference AI': 'muslimReferenceAI',
  'PaliGPT': 'paliGPT',
  //'5D Thinking': 'fiveDThinking',
  default: 'default',
};

export const titleToImageMap = {
  'Nur Al Huda': nurAlHudaImg,
  'Nur Al Huda For Kids': nurAlHudaForKidsImg,
  'Islamic Socratic Method': islamicSocraticMethodImg,
  'Iqra With Us': iqraWithUsImg,
  'Nur Tutor': nurTutorImg,
  //'Muslim Reference AI': muslimReferenceAIIMG,
  'PaliGPT': paliGPTImg,
  //'5D Thinking': fiveDThinkingImg,
};

export const titleToDescriptionMap = {
    'Nur Al Huda': 'An advanced model offering comprehensive support for all your Islamic research needs.',
    'Nur Al Huda For Kids': 'A kid-friendly version of Nur Al Huda, tailored for young learners',
    'Islamic Socratic Method': 'An assistant designed to facilitate Islamic philosophical discussions using the Socratic method. Great for creating a thesis',
    'Iqra With Us': 'A tool that helps you explore and understand Quranic verses, including the Translation, Tafsir, and Application.',
    'Nur Tutor': '🌙 Nur Tutor - A Study Mode Assistant powered by AI, guided by Islamic values. Your personal learning companion that helps students truly understand, not just complete, their work.',
    //'Muslim Reference AI': 'A reference tool providing access to Islamic teachings and scholarly works.',
    'PaliGPT': 'An assistant focused on providing information related to Palestinian History and Culture',
    //'5D Thinking': 'An assistant that integrates spiritual and scientific perspectives based on 5D Thinking Model for holistic teaching.',
  };

// Assistant IDs for OpenAI API
// Note: These are used by the Cloud Functions to identify which assistant to use
export const titleToAssistantIDMap = {
  'Nur Al Huda': "asst_0UOsgGXyWL19iwxrR1tqt56p",
  'Nur Al Huda For Kids': "asst_2z9CBAnU88vgmSnZnNHZVaGz",
  'Islamic Socratic Method': "asst_nUrppuSP9pPPjRPHDD3l13bH",
  'Iqra With Us': "asst_NSjlngEyPNwU1PeAcmZZHC9K",
  'Muslim Reference AI': "asst_gJad0rJeSMH3s4Uo9oTWjE9y",
  'Nur Tutor': "asst_njS38hujGDabzo0EV3bGIzXq",
  'PaliGPT': "asst_ShMxEdN8gnWONFOVVFv8dKTJ",
  'Quiz Generator': "asst_paDb8Yr8jvqDUmFd2q4n1Fbi",
  'Auto Grader': "asst_6RiVocNQqbUn9lyeC3aZsde3",
  '5D Thinking' : "asst_7tVLODKXgClbyXhQCv89DW3w",
  '5D Thinking-1': "asst_zjjLJ9DjptDuCCgwA9uTO51z",
  '5D Thinking-2': "asst_RanK2BnaspTIIM5BqsVvasK5",
  'Slide Generator': "asst_ts7eHBFDcdcMgNeshbNShuvy",
  // Added Flashcard Generator
  'Flashcard Generator': "asst_TE64nI92wr7chWtmBYrRGWOt", 
};